// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2feCj","placeholdersHeader":"styles_placeholdersHeader__1x2uv","editorStyle":"styles_editorStyle__2FXbm","placeholdersBox":"styles_placeholdersBox__2G0Lv"};